import { Grid, IconButton, Typography, makeStyles } from '@material-ui/core';
import { DefaultCard, FormHookResult, RadioButtonGroup } from 'design-system';
import { useState } from 'react';

import { AnyAction } from 'redux';
import PersonDataResponse from 'src/models/responseTypes/PersonValidationResponse';
import { defaultValue as defaultIdType } from '../../../../../constants/idTypes';
import { me, other } from '../../../../../constants/paymentIssuerSource';
import PaymentIssuer, {
  makeEmptyPaymentIssuer,
} from '../../../../../models/helperTypes/PaymentIssuer';

import isEmptyPaymentIssuer from '../../../../../functions/isEmptyPaymentIssuer';

import edit from '../res/edit.svg';
import PaymentIssuerModal from './PaymentIssuerModal';

type Props = {
  getInputProps: FormHookResult;
  currentIssuer: PaymentIssuer;
  onPaymentIssuerChanged: (newIssuer: PaymentIssuer) => void;
  validatePersonAction: (
    idNumber: string,
    idType: string,
  ) => Promise<AnyAction>;
  personValidateData: PersonDataResponse;
  setNewPayerDataFieldsAction: (dataFields: Partial<PaymentIssuer>) => void;
};

const useStyles = makeStyles({
  editLabel: {
    width: 'calc(100% - 24px)',
    display: 'inline-block',
  },
  editIcon: {
    width: 24,
    height: 24,
  },
});

const PaymentIssuerSelectionCards = ({
  getInputProps,
  currentIssuer,
  personValidateData,
  validatePersonAction,
  onPaymentIssuerChanged,
  setNewPayerDataFieldsAction,
}: Props): JSX.Element => {
  const classes = useStyles();

  const [dialogueIsOpen, toggleDialogueIsOpen] = useState(false);
  const [dialogueOnEditMode, toggleDialogueOnEditMode] = useState(false);

  function onNewSourceChanged(newSource: string): void {
    if (newSource === other) {
      toggleDialogueOnEditMode(false);
      toggleDialogueIsOpen(true);
    } else {
      onPaymentIssuerChanged({
        ...makeEmptyPaymentIssuer(),
        idType: defaultIdType,
      });
    }
  }

  return (
    <>
      {/* Issuer Source */}
      <Grid item xs={12}>
        <DefaultCard>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2">
                ¿Quién es la persona que va a pagar la póliza?
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <RadioButtonGroup
                formTitle=""
                radioGroupName="paymentIssuerSource"
                gridSize={12}
                radioData={[
                  { Value: me, Text: 'Yo, como contratante' },
                  { Value: other, Text: 'Otra persona física o jurídica' },
                ]}
                defaultValue={
                  getInputProps('paymentIssuerSource').value as string
                }
                onChange={(newVal): void => {
                  getInputProps('paymentIssuerSource').onChange(newVal.Value);
                  onNewSourceChanged(newVal.Value);
                }}
              />
            </Grid>
          </Grid>
        </DefaultCard>
      </Grid>

      {/* Issuer data (view/edit) */}
      {!isEmptyPaymentIssuer(currentIssuer) && (
        <Grid item xs={12}>
          <Grid item xs={12}>
            <DefaultCard data-testid="view-edit-card">
              <div className={classes.editLabel}>
                <Typography variant="body2">Responsable de pago</Typography>
              </div>
              <IconButton
                data-testid="edit-icon"
                className={classes.editIcon}
                onClick={(): void => {
                  toggleDialogueOnEditMode(true);
                  toggleDialogueIsOpen(true);
                }}
              >
                <img alt="edit" src={edit} />
              </IconButton>
            </DefaultCard>
          </Grid>
        </Grid>
      )}

      {/* Issuer dialogue */}
      <PaymentIssuerModal
        data-testid="payment-issuer-modal"
        editMode={dialogueOnEditMode}
        currentValues={currentIssuer}
        personValidateData={personValidateData}
        validatePersonAction={validatePersonAction}
        setNewPayerDataFieldsAction={setNewPayerDataFieldsAction}
        open={dialogueIsOpen}
        onCloseRequested={(
          mustResetValues: boolean,
          data: PaymentIssuer,
        ): void => {
          toggleDialogueIsOpen(false);
          onPaymentIssuerChanged(data);
          if (mustResetValues) {
            getInputProps('paymentIssuerSource').onChange(me);
          }
        }}
      />
    </>
  );
};

export default PaymentIssuerSelectionCards;
